import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { Motion, spring } from 'react-motion'
import { FlexContainer, FlexItem } from 'components/Flex'
import { CheckList, CheckListItem } from 'components/CheckList'
import scrollToTop from 'decorators/scrollToTop'
import CheckButton from 'components/CheckButton'
import { match } from 'utils/patternMatchUtil'
import './styles.sass'

// Each question gets 33% of screen space,
// this is used to offset the transform
// based on what question we're at.
const OFFSET_AMOUNT = 100

@scrollToTop
@observer
export default class QuestionsStep extends React.Component {
  render () {
    const { step } = this.props
    const { questions, currentQuestionId } = step
    return (
      <div className="questions-step">
        {/* Animates the position of the questions container */}
        <Motion
          defaultStyle={{
            x: step.currentQuestionIndex * -OFFSET_AMOUNT
          }}
          style={{
            x: spring(step.currentQuestionIndex * -OFFSET_AMOUNT, { stiffness: 170, damping: 19 })
          }}
        >
          {({ x }) =>
            <div className="questions-container" style={{ transform: `translateX(${x}%)` }}>
              {questions.map((question) =>
                <Question
                  current
                  question={question}
                  onAnswer={(answer) => step.wizard.isProcessing === false && step.giveAnswer(question.id, answer)}
                  key={question.id}
                  onBreakerClick={() => step.breaker(question)}
                  {...question.id !== currentQuestionId && {
                    current: false
                  }}
                />
              )}
            </div>
          }
        </Motion>
      </div>
    )
  }
}

let Question = ({ question, onAnswer, current, onBreakerClick }) => {
  return (
    <div className={cx('question', current && 'question--active')}>
      <div className="question__text">
        {question.question.trim() /* Remove newline at the end */}
      </div>
      {question.description &&
        <div className="question__description">
          {question.description}
        </div>
      }
      {question.type === 'BOOL' &&
        <div className="question__answers">
          <div className="question__answer-container">
            <CheckButton
              checked={question.answer === true}
              onChange={() => current && onAnswer(true)}
            >
              Yes
            </CheckButton>
          </div>
          <div className="question__answer-container">
            <CheckButton
              checked={question.answer === false}
              onChange={() => current && onAnswer(false)}
            >
              No
            </CheckButton>
          </div>
        </div>
      }
      {question.type === 'SELECT' &&
        <FlexContainer direction="column" className="has-spacing-top">
          <FlexItem>
            <CheckList>
              {question.options.map((option) =>
                <CheckListItem
                  key={option.id}
                  onChange={(checked) => checked && onAnswer(option.id)}
                  checked={question.answer === option.id}
                >
                  {option.text}
                </CheckListItem>
              )}
            </CheckList>
          </FlexItem>
        </FlexContainer>
      }
      {question.type === 'BREAKER' &&
        <FlexContainer direction="column" className="has-spacing-top">
          <FlexItem>
            <button
              className="button is-awesome has-chevron-right"
              onClick={() => onBreakerClick()}
            >
              {match(question.action, {
                GO_TO_PERSONAL_RETURN: 'Start Personal Return',
                GO_TO_PROJECTS: 'Finish',
                [match.DEFAULT]: 'Finish'
              })}
            </button>
          </FlexItem>
        </FlexContainer>
      }
    </div>
  )
}

Question = observer(Question)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/Questions/index.jsx